import { PageHero, SectionHeader, NumberedList } from "@/components/PageChrome";
import CTABanner from "@/components/CTABanner";
import { useSEO } from "@/lib/seo";

const AREAS = [
    {
        title: "Estate Planning",
        body: "Wills, revocable trusts, powers of attorney, healthcare directives, HIPAA authorizations, beneficiary designations, and succession plans built for families and closely-held businesses.",
        href: "/estate-planning",
        testId: "practice-row-estate-planning",
    },
    {
        title: "Elder Law",
        body: "Long-term care planning, Medicaid and VA benefits, special needs trusts, and advance directives for families preparing for the years ahead.",
        href: "/elder-law",
        testId: "practice-row-elder-law",
    },
    {
        title: "Real Estate",
        body: "Purchases, sales, leases, and title work for rural, residential, and commercial property. Deeds, easements, and clean closings.",
        href: "/real-estate-law",
        testId: "practice-row-real-estate",
    },
    {
        title: "Business Law",
        body: "LLC and corporation formation, operating agreements, buy-sell terms, contracts, and day-to-day counsel for closely-held companies and family enterprises.",
        href: "/business-law",
        testId: "practice-row-business-law",
    },
];

const APPROACH = [
    {
        title: "Flat-fee scoping",
        body: "Most estate-planning, entity-formation, and closing work is quoted flat before we begin, in a written engagement letter. No hourly surprises.",
    },
    {
        title: "One attorney, start to finish",
        body: "The attorney you hire is the attorney who drafts, negotiates, and closes. Nothing meaningful is handed off to a junior.",
    },
    {
        title: "Careful documentation",
        body: "Beneficiary designations, deeds, and operating agreements either match, or they don’t. Ours match. Quietly, that is most of the work.",
    },
];

export default function PracticeAreas() {
    useSEO({
        title: "Practice Areas",
        description:
            "Chesterton practice areas: estate planning, elder law, real estate, and business law for landowners, families, and closely-held enterprises.",
        path: "/practice-areas",
    });

    return (
        <>
            <PageHero
                testId="practice-areas-hero"
                kicker="Practice"
                title={<>Practice areas.</>}
                intro="Four disciplines that shape what happens to a family’s land, business, and legacy across a lifetime. We work in all four so your plan, your property, your enterprise, and your later years actually fit together."
            />

            <section className="pb-20 lg:pb-24 bg-acre-bg">
                <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
                    <NumberedList items={AREAS} />
                </div>
            </section>

            <section className="py-20 lg:py-28 bg-white border-y border-acre-line">
                <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
                    <SectionHeader
                        kicker="Approach"
                        title={<>How we work.</>}
                        description="A short list of choices that show up in every engagement, before the first draft is written and after the last document is signed."
                    />
                    <NumberedList items={APPROACH} />
                </div>
            </section>

            <CTABanner />
        </>
    );
}
